// Docs: https://techdocs.akamai.com/ivm/reference/test-images-on-demand
type loaderProps = {
  src: string;
}
export default function akamaiLoader({ src }: loaderProps) {
  return `https://www.autotrader.com/psx-static/main/psx-react-web/${src}`;
}
